export const BASE_URL = process.env.REACT_APP_BASE_URL
export const VERSION = "v2";
export const PROFILE_IMAGE_URL = "ssov2_profile_picture"
export const PROFILE_IMAGE_BASE_URL =
  process.env.REACT_APP_PROFILE_IMAGE_BASE_URL ||
  "https://ssop.fra1.digitaloceanspaces.com";